// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DiffTwoToneSvg from "@ant-design/icons-svg/es/asn/DiffTwoTone";
import AntdIcon from '../components/AntdIcon';

var DiffTwoTone = function DiffTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DiffTwoToneSvg
  }));
};

DiffTwoTone.displayName = 'DiffTwoTone';
export default React.forwardRef(DiffTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DiffTwoTone.js
// module id = 937
// module chunks = 0